<script setup lang="ts">
import SocialRating from '@components/SocialRating.vue';
import Typography from '@components/Typography.vue';
import MediaImage from '@components/MediaImage.vue';
import { trans } from '@tools/translation.ts';
import ButtonLink from '@components/ButtonLink.vue';
import { URL_GUIDED_SEARCH } from '@tools/routes/routes';
import Icon from '@components/Icon.vue';
import { IconArrowRight } from '@icons';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { storeToRefs } from 'pinia';

const { isMobile } = storeToRefs(useScreensizeStore());
</script>

<template>
  <div
    :class="[
      'flex items-center justify-center',
      'bg-[radial-gradient(50%_50%_at_50%_50%,rgba(60,70,220,0.3)_0%,rgba(60,70,220,0)_100%)]',
    ]"
  >
    <div class="flex flex-col items-center gap-y-6">
      <SocialRating />

      <Typography
        variant="content-heading-1"
        class="text-center"
      >
        <span class="font-normal">
          {{ trans('search.card.reinsurance.title.1') }} <br> {{ trans('search.card.reinsurance.title.2') }}
        </span>

        <br> {{ trans('search.card.reinsurance.title.3') }}
      </Typography>

      <ButtonLink
        :href="URL_GUIDED_SEARCH"
        :target="isMobile ? '_self' : '_blank'"
        variant="secondary"
        class="search-reinsurance-card__link"
      >
        <MediaImage
          uuid="62cf3d82-5f9e-4a2f-82d2-bc2a7b493bdd"
          :class="[
            'overflow-hidden',
            'rounded-full border border-solid border-blue-lighter',
            'shrink-0',
            'size-12',
          ]"
          :alt="trans('guided_search.persona_alt')"
          :width="48"
          :ratio="[ 1, 1 ]"
          :density="3"
        />

        <Typography
          variant="body-bold"
          class="whitespace-nowrap"
        >
          {{ trans('search.card.reinsurance.talk_to_expert') }}
        </Typography>

        <Icon
          :svg="IconArrowRight"
          width="24"
          height="24"
          class="shrink-0"
        />
      </ButtonLink>
    </div>
  </div>
</template>

<style scoped lang="scss">
.search-reinsurance-card {
  &__link {
    @apply rounded-[32px];

    @apply border-gray-light hover:bg-gray-light;

    @apply shadow-[0_.125rem_.25rem_0_rgba(0,0,0,.1)] hover:shadow-[0_.25rem_.5rem_rgba(0,0,0,0.25)];

    @apply bg-white;

    @apply h-16 w-[290px];

    @apply p-2 pr-4;

    @apply flex justify-start items-center gap-x-4;
  }
}
</style>
